import React, { useEffect } from "react"
import { Link } from "gatsby"
import {
  navbar,
  left,
  leftDark,
  right,
  rightDark,
  navbarInner,
  activeLink,
  themeButton,
  themeButtonDark,
  bodyLight,
} from "./navbar.module.scss"
import { themeState } from "../state"
import { useRecoilState, useRecoilValue } from "recoil"

import { FaMoon, FaSun } from "react-icons/fa"

const NavigationBar = () => {
  const theme = useRecoilValue(themeState)

  useEffect(() => {
    if (!theme) {
      document.body.classList.add(bodyLight)
    } else {
      document.body.classList.remove(bodyLight)
    }
  }, [theme])
  return (
    <div className={navbar}>
      <div className={navbarInner}>
        <Logo />
        <PageLinks />
      </div>
    </div>
  )
}

const Logo = () => {
  const theme = useRecoilValue(themeState)
  return (
    <div className={theme ? leftDark : left}>
      <div>Logo</div>
    </div>
  )
}

const PageLinks = () => {
  const theme = useRecoilValue(themeState)
  return (
    <div className={theme ? rightDark : right}>
      <Link to="/" activeClassName={activeLink}>
        Home
      </Link>
      <Link to="/work" activeClassName={activeLink}>
        Work
      </Link>
      <Link to="/about" activeClassName={activeLink}>
        About
      </Link>
      <Link to="/contact" activeClassName={activeLink}>
        Contact
      </Link>
      <ThemeSwitchButton />
    </div>
  )
}

const ThemeSwitchButton = () => {
  const [theme, setTheme] = useRecoilState(themeState)

  const toggleTheme = () => {
    setTheme(!theme)
  }

  return (
    <div className={theme ? themeButtonDark : themeButton}>
      {theme ? (
        <FaMoon onClick={toggleTheme} />
      ) : (
        <FaSun onClick={toggleTheme} />
      )}
    </div>
  )
}

export default NavigationBar
